import { render } from "./CharactorDia.vue?vue&type=template&id=0bbd10dc"
import script from "./CharactorDia.vue?vue&type=script&lang=js"
export * from "./CharactorDia.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__